<template>
  <div>
    <v-tooltip right v-if="params && params.data && params.data.is_active">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="text-caption details-sub-title">
          <v-icon class="mr-4 success--text"> mdi-check-circle </v-icon>
        </span>
      </template>
      <span class="text-capitalize">Active</span>
    </v-tooltip>
    <v-tooltip right v-else>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="text-caption details-sub-title">
          <v-icon class="mr-4 error--text"> mdi-close-circle </v-icon>
        </span>
      </template>
      <span class="text-capitalize">Deactivated</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {};
</script>
